import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import sideImage from "../assets/undraw_work_in_progress_re_byic.svg";
import { useLocation } from "react-router-dom"

export default function SpecificInvest() {
  const tol = 50;
  const thres = 20;
  const { state } = useLocation();
  const equity = state.option;
  let investment_list = [];
  if(equity == "Savings"){ investment_list = [
    {
      name: "CHASE",
      risk: 1,
    },
    {
      name: "GOLDMAN SACHS",
      risk: 1,
    },
    {
      name: "PNC",
      risk: 1,
    },
    {
      name: "USAA",
      risk: 1,
    },
    {
      name: "Capital One",
      risk: 1,
    },
    {
      name: "Wells Fargo",
      risk: 1,
    },
    {
      name: "Bear Sterns",
      risk: 1,
    },
    {
      name: "Alliant Credit Union",
      risk: 1,
    },
    {
      name: "Discover",
      risk: 1,
    },
    {
      name: "Bank of America",
      risk: 1,
    },
    {
      name: "Aggieland Credit Union",
      risk: 1,
    },
  ];
}

if(equity == "Bonds"){ investment_list = [
  {
    name: "GB3:GOV",
    risk: 8,
  },
  {
    name: "GB6:GOV",
    risk: 8,
  },
  {
    name: "GB12:GOV",
    risk: 8,
  },
  {
    name: "GT2:GOV",
    risk: 8,
  },
  {
    name: "GT5:GOV",
    risk: 7,
  },
  {
    name: "GT10:GOV",
    risk: 6,
  },
  {
    name: "GT30:GOV",
    risk: 5,
  },
  {
    name: "GTII5:GOV",
    risk: 5,
  },
  {
    name: "GTII10:GOV",
    risk: 5,
  },
  {
    name: "GTII20:GOV",
    risk: 5,
  },
  {
    name: "GTII30:GOV",
    risk: 5,
  },
];

}

if(equity == "Stocks"){ investment_list = [
  {
    name: "TFCAX",
    risk: 12,
  },
  {
    name: "APPL",
    risk: 90,
  },
  {
    name: "ORSTX",
    risk: 30,
  },
  {
    name: "AGRO",
    risk: 49,
  },
  {
    name: "BOCN",
    risk: 60,
  },
  {
    name: "SP500",
    risk: 89,
  },
  {
    name: "BRID",
    risk: 85,
  },
  {
    name: "BRKL",
    risk: 84,
  },
  {
    name: "LKGE",
    risk: 96,
  },
  {
    name: "SNN",
    risk: 23,
  },
  {
    name: "RSLS",
    risk: 45,
  },
];

}
  let categorizeInvestList = [[], [], []];
  const categorizeInvest = () => {
    for (let i = 0; i < investment_list.length; i++) {
      if (investment_list[i].risk <= tol - thres) {
        categorizeInvestList[0].push(investment_list[i]);
      } else if (investment_list[i].risk >= tol + thres) {
        categorizeInvestList[2].push(investment_list[i]);
      } else {
        categorizeInvestList[1].push(investment_list[i]);
      }
    }
  };
  categorizeInvest();

  function perc2color(perc) {
    perc = perc - 100;
    perc = Math.abs(perc)
    var r,
      g,
      b = 0;
    if (perc < 50) {
      r = 255;
      g = Math.round(5.1 * perc);
    } else {
      g = 255;
      r = Math.round(510 - 5.1 * perc);
    }
    var h = r * 0x10000 + g * 0x100 + b * 0x1;
    return "#" + ("000000" + h.toString(16)).slice(-6);
  }

  return (
    // retreive data. For now is hardcoded
    <div className="h-screen">
      <Navbar />
      <div className="w-full flex flex-col justify-center items-center overflow-hidden">
        <div className="grid lg:grid-cols-5">
          {/* Recommend */}
          <div className="grid lg:grid-cols-3 col-span-3 col-start-2 gap-x-10 gap-y-5">
            <div className="h-[1/3] mt-8 col-span-3 text-[#636B90] text-4xl m-2 font-bold text-2xl underline">
              Recommend
            </div>
            {categorizeInvestList[0].map((item, index) => (
              <div className="bg-white border border-4 border-[#73C4FC] text-black font-bold py-12 px-24 rounded-lg text-xl">
                <label
                  class=""
                  className="flex justify-center items-center whitespace-nowrap "
                >
                  {item.name}
                </label>
                <label
                  class=""
                  className="flex justify-center items-center whitespace-nowrap"
                  style={{
                    color: perc2color(item.risk),
                  }}
                >
                  {item.risk}
                </label>
              </div>
            ))}
          </div>

          {/* Risker */}
          <div className="grid lg:grid-cols-3 col-span-3 col-start-2 gap-x-10 gap-y-5">
            <div className="h-[1/3] mt-8 col-span-3  text-[#636B90] text-4xl m-2 font-bold text-2xl underline">
              Riskier
            </div>
            {categorizeInvestList[2].map((item, index) => (
              <div className="bg-white border border-4 border-[#73C4FC] text-black font-bold py-12 px-24 rounded-lg text-2xl">
                <label
                  class=""
                  className="flex justify-center items-center whitespace-nowrap "
                >
                  {item.name}
                </label>
                <label
                  class=""
                  className="flex justify-center items-center whitespace-nowrap "
                  style={{ color: perc2color(item.risk) }}
                >
                  {item.risk}
                </label>
              </div>
            ))}
          </div>
          <div class="h-auto max-w-full rounded-lg lg:inline-block pt-16">
            <img src={sideImage} alt="..." class="bg-fill height-auto" />
          </div>
          {/* Safer */}
          <div className="grid lg:grid-cols-3 col-span-3 col-start-2 gap-x-10 gap-y-5">
            <div className="h-[1/3] mt-8 col-span-3 text-[#636B90] text-4xl m-2 font-bold text-2xl underline">
              Safer
            </div>
            {categorizeInvestList[1].map((item, index) => (
              <div className="bg-white border border-4 border-[#73C4FC] text-black font-bold py-12 px-24 rounded-lg text-2xl mb-8">
                <label
                  class=""
                  className="flex justify-center items-center whitespace-nowrap"
                >
                  {item.name}
                </label>
                <label
                  class=""
                  className="flex justify-center items-center whitespace-nowrap "
                  style={{ color: perc2color(item.risk) }}
                >
                  {item.risk}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
